import { CurrencyEnum } from './currency-enum';

export class Constants {
  static currencyFormat = '1.0-0';
}

export const currencyList =
  [
    {
      currency: CurrencyEnum.USD,
      country: 'us',
    },
    {
      currency: CurrencyEnum.EUR,
      country: 'eu',
    },
    {
      currency: CurrencyEnum.GBP,
      country: 'gb',
    },
  ];